/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable arrow-body-style */
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Box, Link, Typography, Stack, MenuItem } from '@mui/material';
// routes
import { PATH_DASHBOARD } from '../../../../routes/paths';
// utils
import { fDate } from '../../../../utils/formatTime';
// @types
// components
import Image from '../../../../components/Image';
import TextMaxLine from '../../../../components/TextMaxLine';
import SvgIconStyle from '../../../../components/SvgIconStyle';
import { StyledAvatar, StyledCardContainer, StyledCardContent } from '../styles';
import { TableMoreMenu } from 'src/components/table';
import { useState } from 'react';
import Iconify from 'src/components/Iconify';
import useIsFullAdmin from 'src/hooks/useIsFullAdmin';
import { Blog } from '../../../../@types/blog';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

type Props = {
  blog: Blog;
  index?: number;
  handleEditRow(): void;
  handleDeleteRow(): void;
};

export default function BlogCard({ blog, index, handleDeleteRow, handleEditRow }: Props) {
  return (
    <StyledCardContainer>
      <Box sx={{ position: 'relative' }}>
        <SvgIconStyle
          src="https://minimal-assets-api-dev.vercel.app/assets/icons/shape-avatar.svg"
          sx={{
            zIndex: 9,
            width: 80,
            height: 36,
            bottom: -15,
            position: 'absolute',
            color: 'background.paper',
          }}
        />
        {/*<StyledAvatar alt={blog.title} src={blog.icon} />*/}
        <Image alt="cover" src={blog.image} ratio="4/3" />
      </Box>

      <CardContent blog={blog} handleDeleteRow={handleDeleteRow} handleEditRow={handleEditRow} />
    </StyledCardContainer>
  );
}

// ----------------------------------------------------------------------

type TrackContentProps = {
  blog: Blog;
  handleEditRow(): void;
  handleDeleteRow(): void;
};

function CardContent({ blog, handleEditRow, handleDeleteRow }: TrackContentProps) {
  const linkTo = PATH_DASHBOARD.blogs;

  return (
    <StyledCardContent>
      <Stack>
        <Stack
          direction={'row'}
          width={'100%'}
          justifyContent={'space-between'}
          alignItems={'center'}
          mb={1}
        >
          <Typography variant="caption" component="div" color={'text.disabled'}>
            {fDate(blog.createdAt as string)}
          </Typography>
          <ToolBar onEditRow={handleEditRow} onDeleteRow={handleDeleteRow} row={blog} />
        </Stack>
        <Stack
          direction={'row'}
          width={'100%'}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <TextMaxLine sx={{ width: 'auto !important' }} variant={'subtitle2'} line={2} persistent>
            {blog.title}
          </TextMaxLine>

          {/*<TextMaxLine*/}
          {/*    sx={{ width: 'auto !important' }}*/}
          {/*    variant={'body2'}*/}
          {/*    color={'text.disabled'}*/}
          {/*    line={2}*/}
          {/*    persistent*/}
          {/*>*/}
          {/*  {blog?.category?.title}*/}
          {/*</TextMaxLine>*/}
        </Stack>
        <Typography
          gutterBottom
          variant="caption"
          height={'150px'}
          component="div"
          color={'text.disabled'}
        >
          {blog.description}
        </Typography>
      </Stack>
    </StyledCardContent>
  );
}

export const ToolBar = ({
  onEditRow,
  row,
  onDeleteRow,
}: {
  row: Blog;
  onEditRow(): void;
  onDeleteRow(): void;
}) => {
  const [openMenu, setOpenMenuActions] = useState<HTMLElement | null>(null);
  const navigate = useNavigate();
  // DELETE /blogs/:id is admin-only on the backend, while create/edit are open
  // to customer-care and sales. Showing Delete to them was a button that always
  // 403s and leaves the post in place.
  const canDelete = useIsFullAdmin();

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setOpenMenuActions(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  };

  return (
    <TableMoreMenu
      open={openMenu}
      onOpen={handleOpenMenu}
      onClose={handleCloseMenu}
      actions={
        <>
          <MenuItem
            onClick={() => {
              onEditRow();
              handleCloseMenu();
            }}
          >
            <Iconify icon={'eva:edit-fill'} />
            Edit
          </MenuItem>
          {canDelete && (
            <MenuItem
              onClick={() => {
                onDeleteRow();
                handleCloseMenu();
              }}
              sx={{ color: 'error.main' }}
            >
              <Iconify icon={'eva:trash-2-outline'} />
              Delete
            </MenuItem>
          )}
        </>
      }
    />
  );
};
